module.exports = __webpack_public_path__ + "img/ski_sub_title8.c638e2e0.jpg";